// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2gDmO","label":"SetPasswdForm_label__8kD57"};